import { Positions } from '@/models/enums'

export const ALLOWED_POSITION = [
  Positions.T,
  Positions.B,
  Positions.L,
  Positions.R,
  Positions.TL,
  Positions.TR,
  Positions.BL,
  Positions.BR,
]

export const CLASS_SELECTED_OPTION = 'lp-select-option-focused'
export const SEARCH_BOX_HEIGHT = 55
